import { MESSAGE_GROUP_PARTS } from './messageGroupParts';
import type { MessageGroupStyleConfig } from './types';

export const MESSAGE_GROUP_STYLE_CONFIG: MessageGroupStyleConfig = {
  parts: MESSAGE_GROUP_PARTS,
  baseStyle: () => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        pb: 2.5,
        mx: 1.25,
      },
      userMessage: {
        border: '1px solid',
        px: 1.5,
        py: 1,
        borderColor: 'separator.border',
        borderRadius: 'md',
        boxShadow: 'popover',
        bg: 'page.plateLight',
        position: 'sticky',
        top: '0rem',
        zIndex: '1',
        fontSize: 'md',
        fontWeight: 'default',
      },
      agentMessageContent: {
        display: 'flex',
        flexDirection: 'column',
        px: 1.5,
        gap: 1,
        mt: 1.5,
      },
    };
  },
  defaultProps: {},
};
